import PendingReviewsDashboardModal from "./PendingReviewsDashboardModal";

export default PendingReviewsDashboardModal;
